"use client";

import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const EMON_URL = "https://emonboost.com/emon";

export default function Emon(): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppHeader currentPage="emon" />

      <main className="flex-1 flex items-center justify-center px-4 pt-20 pb-24">
        <div className="max-w-md w-full text-center space-y-6">
          <h1 className="text-2xl font-semibold text-foreground">EMON Token</h1>

          <p className="text-muted-foreground">
            This page cannot be embedded due to security restrictions. Open it directly to view the full content.
          </p>

          <Button asChild size="lg" className="w-full">
            <a href={EMON_URL} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="mr-2 h-4 w-4" />
              Open EMON Page
            </a>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
}
